import type { SVGProps } from "react";
const SvgIconOverview = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024" {...props}>
    <circle cx={512} cy={512} r={512} fill="currentColor" />
    <rect width={288} height={288} x={192} y={192} rx={50} ry={50} />
    <rect width={288} height={288} x={544} y={192} rx={50} ry={50} />
    <rect width={288} height={288} x={192} y={544} rx={50} ry={50} />
    <rect width={288} height={288} x={544} y={544} rx={50} ry={50} />
  </svg>
);
export default SvgIconOverview;
